import React, {useState} from 'react';
import LoginForm from './LoginForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUserCircle} from '@fortawesome/free-solid-svg-icons/faUserCircle';
import {faUnlockAlt} from '@fortawesome/free-solid-svg-icons/faUnlockAlt';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import useInputState from '../../components/hooks/forms/useInputState';
import styles from '../styles/login/LoginForm.module.css';

const LoginBlock = (props) => {
    const {xs, sm, lg, redirectUrl, openAccountLink, defaultEmail} = props;
    const [tryLogin, editTryLogin] = useState(true);
    const [email, setEmail, resetEmail] = useInputState(defaultEmail ? defaultEmail : '');
    const [resetStep, editResetStep] = useState('email');

    const pageTitleReset = (resetStep) => {
        switch(resetStep) {
            case 'email':
                return 'Recuperează parola';
            case 'token':
                return 'Verifică-ți contul de email';
            case 'password':
                return 'Completează noua parolă';
        }
    };

    const form = tryLogin ? 
                <LoginForm 
                    editTryLogin={editTryLogin} 
                    setEmail={setEmail}  
                    email={email}
                    redirectUrl={redirectUrl}
                    openAccountLink={openAccountLink}
                /> : 
                <ForgotPasswordForm 
                    tryLogin={editTryLogin} 
                    email={email} 
                    setEmail={setEmail}
                    resetStep={resetStep}
                    editResetStep={editResetStep}
                />;

    const title = tryLogin ? 'Conectează-te în cont': pageTitleReset(resetStep);
    const icon = tryLogin ? faUserCircle : faUnlockAlt;

    return (   
            <Col xs={xs} sm={sm} lg={lg} className={`bg-white p-5 mx-auto ${styles.frameBorder}`}>
                <h1 className="heading2 black-text text-center">{title}</h1>
                <p className="text-center green"><FontAwesomeIcon icon={icon} size="5x" height={60} width={60}/></p>
                {form}
            </Col>
    );
}

export default LoginBlock;